module.exports = __webpack_public_path__ + "img/decast-icon-alt.c0f9ec29.svg";